// extracted by mini-css-extract-plugin
export var details = "_dt-0";
export var inspectorPopover = "_dt-1";